var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('DetailSectionColumnLayout',{attrs:{"itemPerColumns":[12, 12],"modelData":_vm.user,"labelKey":"labelDetail","listFields":_vm.$store.getters.professionalInfoFields,"listExcludeFields":[]}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a09025c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/candidates/profile/ProfessionalInfo.vue
// module id = 655
// module chunks = 0